import React, { useEffect } from 'react';
import { bool, func, shape } from 'prop-types';
import { VideoPlayer } from '@thd-olt-component-react/video-player';
import { Image } from '@thd-olt-component-react/image';
import Helper from '../../Helper';
import Threesixty from '../Threesixty';
import { dataModel } from '../../dataModel';

export const InteractiveMediaOverlay = ({ mainImage, onClose, open }) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('popstate', onClose, false);
    }
    return function cleanup() {
      window.removeEventListener('popstate', onClose, false);
      document.body.style.overflow = 'auto';
    };
  }, []);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [open]);

  const isVideo = Helper.isVideo({ media: mainImage });
  const isImage360 = Helper.isImage360({ media: mainImage });
  const showHideClassName = open ? 'overlay-mobile overlay-mobile__display-block' : 'overlay-mobile overlay-mobile__display-none';

  return (
    <div className={showHideClassName}>
      <section className="overlay-mobile__wrapper">
        <div className="overlay-mobile__main-content">
          <button type="button" className="overlay-mobile__close-button" onClick={onClose}>
            <Image
              className="overlay-mobile__close"
              src="https://assets.homedepot-static.com/images/v1/close-symbol-orange.svg"
              alt="close"
              lazy
            />
          </button>
        </div>
        {isImage360 && (
          <div className="overlay-mobile__main-content overlay-mobile__main-content-landscape">

            <Threesixty
              media={mainImage}
            />

          </div>
        )}
        {isVideo && (
          <div className="overlay-mobile__main-content overlay-mobile__main-content-landscape overlay-mobile__main-content-landscape__video">
            <VideoPlayer iframe videoId={mainImage.videoId} channel="mobile" autoPlay />
          </div>
        )}
      </section>
    </div>
  );
};

InteractiveMediaOverlay.displayName = 'InteractiveMediaOverlay';

InteractiveMediaOverlay.propTypes = {
  onClose: func.isRequired,
  mainImage: shape({}).isRequired,
  open: bool.isRequired
};

InteractiveMediaOverlay.dataModel = dataModel;
